import { render, staticRenderFns } from "./PhysicalsIcon.vue?vue&type=template&id=2396de02&scoped=true&"
import script from "./PhysicalsIcon.vue?vue&type=script&lang=ts&"
export * from "./PhysicalsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2396de02",
  null
  
)

export default component.exports